<template>
  <div
    id="cross-ecology"
    ref="crossEcologyRef"
    class="cross-ecology"
    data-sidebar="4"
  >
    <!-- 第一屏，摇一摇 -->
    <div class="shake-screen" data-position="0" data-name="摇一摇">
      <PlusImage v-if="!isPC" class="shake-bg" :src="shakeImg" alt="" />
      <div :class="{ 'shake-pc-wrap': isPC }">
        <div class="shake-title ffm600" v-animate>跨生态，都好用</div>
        <div class="share-wrap" v-animate>
          <div class="share-title ffm500">摇一摇群组分享</div>
          <div class="share-subtitle ffm600">摇一摇，照片成群飞来</div>
          <div v-if="isMobile" class="share-desc">
            <span class="ffm400">面对面摇一摇，多台设备就能快速建立群组。</span>
            <span class="ffm400">选好照片，简单几步，高清图片飞速共享，</span>
            <span class="ffm400">共享文件流量零消耗。</span>
          </div>
          <div v-else class="share-desc">
            <span class="ffm400">面对面摇一摇，多台设备就能快速建立群组。</span>
            <span class="ffm400"
              >选好照片，简单几步，高清图片飞速共享，共享文件流量零消耗。</span
            >
          </div>
        </div>
      </div>
      <video
        v-if="isPC"
        class="shake-video"
        ref="shakeVideo"
        :src="VIDEOS.shake"
        muted
        alt=""
      ></video>
    </div>
    <!-- 第二屏，办公套件 -->
    <MultInterconnection />
    <!-- 第三屏，跨端生态 -->
    <div class="cross-end-screen">
      <!-- 与ios互联 -->
      <div class="cross-ios" data-position="1" data-name="iPad互联" v-animate>
        <PlusImage class="cross-bg" :src="crossiosImg" alt="" />
        <div class="ios-wrap">
          <div class="ios-title ffm500">iPad互联</div>
          <div v-if="isMobile" class="ios-subtitle ffm600">
            与苹果超合拍，丝滑跨生态
          </div>
          <div v-else class="ios-subtitle ffm600">
            与苹果超合拍，<br />丝滑跨生态
          </div>
          <div class="ios-desc ffm400">
            iPad可以查看并下载vivo手机的图片、音视频和文件，还能接力手机拍照、截图，同时，vivo手机画面也能便捷投屏至iPad。
          </div>
        </div>
      </div>
      <div
        class="cross-other"
        data-position="2"
        data-name="一句话控家"
        v-animate
      >
        <div class="cross-home">
          <div style="position: relative; z-index: 1">
            <div class="home-title ffm500">一句话控家</div>
            <div class="home-subtitle ffm600">智能家居，一句话全搞定</div>
            <div class="home-desc ffm400">
              不用切换App，对着蓝心小V说一句指令，就能一次性完成空调、灯光、空气净化器等多品牌多设备的组合操作。
            </div>
          </div>
          <PlusImage
            class="home-img"
            :src="
              isPC
                ? CROSS_ECOLOGY.crosshome
                : isPad
                ? CROSS_ECOLOGY.crosshomePad
                : CROSS_ECOLOGY.crosshomeH5
            "
            alt=""
          />
        </div>
        <div class="cross-home">
          <div class="home-title ffm500">镜像小窗2.0</div>
          <div class="home-subtitle ffm600">把手机搬上车机</div>
          <div class="home-desc ffm400">
            通过窗口镜像投屏，我们将手机的完整能力，搬到了车机大屏。聊天、追剧、导航一应俱全。
          </div>
          <PlusImage
            class="car-img"
            :src="
              isPC
                ? CROSS_ECOLOGY.crosscar
                : isPad
                ? CROSS_ECOLOGY.crosscarPad
                : CROSS_ECOLOGY.crosscarH5
            "
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import MultInterconnection from "./MultInterconnection.vue";
import { CROSS_ECOLOGY } from "@/config/image.js";
import { initExposureTrack } from "@/utils/track.js";
import VIDEOS from "@/config/video";
import observerManager from "@/utils/observerManager";
import { ScrollTrigger } from "@/utils/gsapConfig";

export default {
  name: "CrossEcology",
  components: {
    MultInterconnection,
  },
  data() {
    return {
      CROSS_ECOLOGY,
      VIDEOS,
      scrollTriggerInstance: null,
    };
  },
  computed: {
    ...mapGetters(["isPC", "isPad", "isMobile"]),
    shakeImg() {
      if (this.isPC) {
        return this.CROSS_ECOLOGY.shake;
      } else if (this.isPad) {
        return this.CROSS_ECOLOGY.shakePad;
      } else {
        return this.CROSS_ECOLOGY.shakeH5;
      }
    },
    crossiosImg() {
      if (this.isPC) {
        return this.CROSS_ECOLOGY.crossios;
      } else if (this.isPad) {
        return this.CROSS_ECOLOGY.crossiosPad;
      } else {
        return this.CROSS_ECOLOGY.crossiosH5;
      }
    },
  },
  mounted() {
    initExposureTrack(".cross-ecology [data-position]")();
    if (this.isPC) {
      this.initGsap();
      this.initVideoObserver();
    }
    let lastWidth = window.innerWidth;
    this.resizeHandler = () => {
      if (this.isPC) {
        try {
          if (Math.abs(window.innerWidth - lastWidth) > 10) {
            lastWidth = window.innerWidth;
            if (this.scrollTriggerInstance) {
              this.scrollTriggerInstance.kill();
              this.initGsap();
            }
            this.initVideoObserver();
          }
        } catch (error) {
          console.log(error);
        }
      }
    };
    window.addEventListener("resize", this.resizeHandler);
  },
  beforeDestroy() {
    this.destroyScrollTrigger();
  },
  methods: {
    initGsap() {
      const container = this.$refs.crossEcologyRef;
      if (!container) return;

      if (this.scrollTriggerInstance) {
        this.scrollTriggerInstance.kill();
      }

      this.scrollTriggerInstance = ScrollTrigger.create({
        // markers: true,
        trigger: container,
        start: "top top-=" + (window.innerWidth / 1920) * 260,
        end: "+=" + (window.innerWidth / 1920) * 800,
        pin: true,
      });
    },
    initVideoObserver() {
      observerManager.observe(
        this.$refs.shakeVideo,
        this.handleContentIntersection.bind(this),
        {
          root: null,
          rootMargin: "0px",
          threshold: 0.8,
        }
      );
    },
    handleContentIntersection(isIntersecting) {
      const video = this.$refs.shakeVideo;
      if (!video) return;

      let playPromise;
      if (isIntersecting) {
        playPromise = video.play();
        if (playPromise && typeof playPromise.then === "function") {
          playPromise.catch(() => {});
        }
      } else {
        // 离开视口：暂停并重置到开始
        try {
          if (playPromise && typeof playPromise.then === "function") {
            playPromise.then((_) => {
              video.pause();
            });
          }
        } catch (e) {}
        video.currentTime = 0;
      }
    },
    destroyScrollTrigger() {
      if (this.scrollTriggerInstance) {
        this.scrollTriggerInstance.kill();
        this.scrollTriggerInstance = null;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.cross-ecology {
  height: 100%;
  width: 100%;
  position: relative;

  // 第一屏
  .shake-screen {
    width: 100%;
    height: fit-content;
    position: relative;
    font-size: 0;

    .shake-bg {
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      object-fit: cover;
    }

    .shake-pc-wrap {
      height: 580 * $px1920vw + vw;
      font-size: 0;
      background: linear-gradient(180deg, #caeeff 0%, #ffffff 100%);
    }

    .shake-video {
      width: 100%;
      height: auto;
    }

    .shake-title {
      width: fit-content;
      margin: 0 auto;
      padding-top: 140 * $px1920vw + vw;
      font-size: 96 * $px1920vw + vw;
      line-height: 116 * $px1920vw + vw;
      text-align: center;
      letter-spacing: normal;
      background: linear-gradient(270deg, #2940c1 0%, #3d94cb 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      text-fill-color: transparent;
      z-index: 2;
      position: relative;
    }

    .share-wrap {
      width: fit-content;
      position: sticky;
      margin: 0 auto;
      z-index: 2;
      margin-top: 126 * $px1920vw + vw;

      .share-title {
        font-size: 28 * $px1920vw + vw;
        line-height: 34 * $px1920vw + vw;
        color: #0f77ff;
      }

      .share-subtitle {
        font-size: 64 * $px1920vw + vw;
        line-height: 77 * $px1920vw + vw;
        letter-spacing: normal;
        color: #000000;
        word-break: keep-all;
        text-align: left;
        margin-top: 12 * $px1920vw + vw;
      }

      .share-desc {
        letter-spacing: normal;
        display: flex;
        flex-direction: column;
        align-items: baseline;
        margin-top: 24 * $px1920vw + vw;
        text-align: center;

        span {
          width: 100%;
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }
  }

  // 第三屏
  .cross-end-screen {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    background-color: #fff;
    padding-top: 120 * $px1920vw + vw;
    padding-bottom: 120 * $px1920vw + vw;

    .cross-ios {
      width: 1200 * $px1920vw + vw;
      height: 600 * $px1920vw + vw;
      background: #f5f5f7;
      border-radius: 16 * $px1920vw + vw;
      overflow: hidden;
      position: relative;

      .cross-bg {
        width: 100%;
        height: 100%;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1;
      }

      .ios-wrap {
        margin-top: 148 * $px1920vw + vw;
        margin-left: 48 * $px1920vw + vw;
        text-align: left;
        position: relative;
        z-index: 2;

        .ios-title {
          font-size: 28 * $px1920vw + vw;
          line-height: 33.6 * $px1920vw + vw;
          color: #0f77ff;
        }

        .ios-subtitle {
          width: 280 * $px1920vw + vw;
          font-size: 40 * $px1920vw + vw;
          line-height: 48 * $px1920vw + vw;
          color: #000000;
          word-break: keep-all;
          margin-top: 12 * $px1920vw + vw;
        }

        .ios-desc {
          margin-top: 24 * $px1920vw + vw;
          width: 307 * $px1920vw + vw;
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(0, 0, 0, 0.6);
        }
      }
    }

    .cross-other {
      width: 1200 * $px1920vw + vw;
      display: flex;
      justify-content: space-between;
      margin-top: 24 * $px1920vw + vw;

      .cross-home {
        width: 588 * $px1920vw + vw;
        height: 600 * $px1920vw + vw;
        border-radius: 24 * $px1920vw + vw;
        background: #f5f5f7;
        text-align: left;
        overflow: hidden;
        position: relative;
        padding-top: 48 * $px1920vw + vw;

        .home-title {
          font-size: 24 * $px1920vw + vw;
          line-height: 29 * $px1920vw + vw;
          color: #0f77ff;
          padding-left: 48 * $px1920vw + vw;
        }

        .home-subtitle {
          font-size: 32 * $px1920vw + vw;
          line-height: 39 * $px1920vw + vw;
          color: #000000;
          margin-top: 8 * $px1920vw + vw;
          padding-left: 48 * $px1920vw + vw;
        }

        .home-desc {
          width: 481 * $px1920vw + vw;
          font-size: 18 * $px1920vw + vw;
          line-height: 25.2 * $px1920vw + vw;
          color: rgba(0, 0, 0, 0.6);
          margin-top: 16 * $px1920vw + vw;
          padding-left: 48 * $px1920vw + vw;
          box-sizing: content-box;
        }

        .home-img {
          width: 100%;
          position: absolute;
          left: 0 * $px1920vw + vw;
          top: 0 * $px1920vw + vw;
        }

        .car-img {
          width: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
      }
    }
  }
}

.isPad {
  .cross-ecology {
    .shake-screen {
      height: 710 * $px676vw + vw;

      .shake-title {
        font-size: 42 * $px676vw + vw;
        line-height: 49 * $px676vw + vw;
        padding-top: 66 * $px676vw + vw;
      }

      .share-wrap {
        text-align: center;
        position: sticky;
        width: 100%;

        .share-title {
          font-size: 12 * $px676vw + vw;
          line-height: 14 * $px676vw + vw;
          text-align: center;
          margin-top: 62 * $px676vw + vw;
        }

        .share-subtitle {
          width: 100%;
          font-size: 25 * $px676vw + vw;
          line-height: 29 * $px676vw + vw;
          text-align: center;
          margin-top: 6 * $px676vw + vw;
        }

        .share-desc {
          width: 100%;
          text-align: center;
          margin-top: 12 * $px676vw + vw;

          span {
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            width: 100%;
          }
        }
      }
    }

    .cross-end-screen {
      padding-top: 36 * $px676vw + vw;
      padding-bottom: 36 * $px676vw + vw;

      .cross-ios {
        width: 596 * $px676vw + vw;
        height: 300 * $px676vw + vw;
        border-radius: 16 * $px676vw + vw;
        background-color: #f5f5f7;

        .ios-wrap {
          margin-top: 79 * $px676vw + vw;
          margin-left: 36 * $px676vw + vw;

          .ios-title {
            font-size: 12 * $px676vw + vw;
            line-height: 14 * $px676vw + vw;
            color: #2785ff;
          }

          .ios-subtitle {
            font-size: 20 * $px676vw + vw;
            line-height: 23 * $px676vw + vw;
            margin-top: 6 * $px676vw + vw;
            width: 140 * $px676vw + vw;
          }

          .ios-desc {
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            width: 194 * $px676vw + vw;
            color: rgba(0, 0, 0, 0.8);
          }
        }
      }

      .cross-other {
        width: 596 * $px676vw + vw;
        margin-top: 20 * $px676vw + vw;

        .cross-home {
          width: 288 * $px676vw + vw;
          height: 360 * $px676vw + vw;
          border-radius: 16 * $px676vw + vw;
          padding-top: 26 * $px676vw + vw;

          .home-title {
            font-size: 12 * $px676vw + vw;
            line-height: 14 * $px676vw + vw;
            padding-left: 22 * $px676vw + vw;
          }

          .home-subtitle {
            font-size: 20 * $px676vw + vw;
            line-height: 23 * $px676vw + vw;
            padding-left: 22 * $px676vw + vw;
            margin-top: 6 * $px676vw + vw;
          }

          .home-desc {
            font-size: 12 * $px676vw + vw;
            line-height: 16 * $px676vw + vw;
            padding-left: 22 * $px676vw + vw;
            margin-top: 12 * $px676vw + vw;
            width: 240 * $px676vw + vw;
          }
        }
      }
    }
  }
}

.isMobile {
  .cross-ecology {
    .shake-screen {
      height: 600 * $px360vw + vw;

      .shake-title {
        font-size: 42 * $px360vw + vw;
        line-height: 49 * $px360vw + vw;
        padding-top: 42 * $px360vw + vw;
      }

      .share-wrap {
        text-align: center;
        position: sticky;
        width: 100%;

        .share-title {
          font-size: 12 * $px360vw + vw;
          line-height: 14 * $px360vw + vw;
          text-align: center;
          margin-top: 86 * $px360vw + vw;
        }

        .share-subtitle {
          width: 100%;
          font-size: 25 * $px360vw + vw;
          line-height: 29 * $px360vw + vw;
          text-align: center;
          margin-top: 6 * $px360vw + vw;
        }

        .share-desc {
          width: 100%;
          text-align: center;
          margin-top: 12 * $px360vw + vw;

          span {
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            width: 100%;
          }
        }
      }
    }

    // 第三屏
    .cross-end-screen {
      padding-top: 36 * $px360vw + vw;
      padding-bottom: 36 * $px360vw + vw;

      .cross-ios {
        width: 320 * $px360vw + vw;
        height: 360 * $px360vw + vw;
        border-radius: 10px;
        background-color: #f5f5f7;

        .ios-wrap {
          margin-top: 28 * $px360vw + vw;
          margin-left: 22 * $px360vw + vw;
          margin-right: 20 * $px360vw + vw;

          .ios-title {
            font-size: 12 * $px360vw + vw;
            line-height: 14 * $px360vw + vw;
            color: #2785ff;
          }

          .ios-subtitle {
            width: 100%;
            font-size: 20 * $px360vw + vw;
            line-height: 23 * $px360vw + vw;
            margin-top: 6 * $px360vw + vw;
          }

          .ios-desc {
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            width: 100%;
            margin-top: 12 * $px360vw + vw;
            color: rgba(0, 0, 0, 0.8);
          }
        }
      }

      .cross-other {
        display: inline-block;
        width: 100%;
        margin-top: 0;

        .cross-home {
          width: 320 * $px360vw + vw;
          height: 360 * $px360vw + vw;
          border-radius: 10px;
          background-color: #f5f5f7;
          margin: 0 auto;
          margin-top: 20 * $px360vw + vw;
          padding-left: 22 * $px360vw + vw;
          padding-top: 28 * $px360vw + vw;
          padding-right: 20 * $px360vw + vw;

          .home-title {
            font-size: 12 * $px360vw + vw;
            line-height: 14 * $px360vw + vw;
            color: #2785ff;
          }

          .home-subtitle {
            width: 100%;
            font-size: 20 * $px360vw + vw;
            line-height: 23 * $px360vw + vw;
            margin-top: 6 * $px360vw + vw;
          }

          .home-desc {
            font-size: 12 * $px360vw + vw;
            line-height: 16 * $px360vw + vw;
            width: 100%;
            margin-top: 12 * $px360vw + vw;
            color: rgba(0, 0, 0, 0.8);
          }

          .home-bottom-wrap {
            .home-bottom-item {
              font-size: 13.19 * $px360vw + vw;
              height: 31.32 * $px360vw + vw;
              padding: 0 12 * $px360vw + vw;
              border-radius: 9.28 * $px360vw + vw;

              &.home-bottom-item-1 {
                left: 18 * $px360vw + vw;
                bottom: 107 * $px360vw + vw;
              }

              &.home-bottom-item-2 {
                right: 18 * $px360vw + vw;
                bottom: 175 * $px360vw + vw;
              }
            }

            .home-img {
              width: 185.6 * $px360vw + vw;
              left: 73 * $px360vw + vw;
              top: 172 * $px360vw + vw;
            }
          }

          .car-img {
            width: 320 * $px360vw + vw;
            bottom: 0;
            top: unset;
          }
        }
      }
    }
  }
}

@media (prefers-color-scheme: dark) {
  .isPad,
  .isMobile {
    .cross-ecology {
      .shake-screen {
        background: #fff;
      }
      .cross-end-screen {
        background: #222;
        .cross-ios,
        .cross-other .cross-home {
          background: #000;
          .ios-wrap {
            .ios-subtitle {
              color: #fff;
            }
            .ios-desc {
              color: #eee;
            }
          }
          .home-subtitle {
            color: #fff;
          }
          .home-desc {
            color: #eee;
          }
        }
      }
    }
  }
}
</style>